import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

import { AuthStore } from '@yoshu-lib/core/auth/auth.store'

export const redirectIfAuthGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore)
  const router = inject(Router)

  if (authStore.currentUser()) {
    router.navigate([''])
    return false
  }

  return true
}
